import { render, staticRenderFns } from "./RiskAlert.vue?vue&type=template&id=9a9cb04a&scoped=true"
import script from "./RiskAlert.vue?vue&type=script&lang=ts"
export * from "./RiskAlert.vue?vue&type=script&lang=ts"
import style0 from "./RiskAlert.vue?vue&type=style&index=0&id=9a9cb04a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9cb04a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a9cb04a')) {
      api.createRecord('9a9cb04a', component.options)
    } else {
      api.reload('9a9cb04a', component.options)
    }
    module.hot.accept("./RiskAlert.vue?vue&type=template&id=9a9cb04a&scoped=true", function () {
      api.rerender('9a9cb04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/CarePlanSteps/RiskAlert.vue"
export default component.exports